'use strict';

import ListEditablesView from 'commons/views/ListEditables';
import template from '../../templates/coupons/Main.ejs';
import ModalView from './Modal.js';
import RowView from './Row.js';
import Coupon from 'newModels/coupon';

module.exports = ListEditablesView.extend({
    itemViews: [],
    modalView: null,

    events: function() {
        var parentEvents = _.isFunction(ListEditablesView.prototype.events) ?
            ListEditablesView.prototype.events() :
            ListEditablesView.prototype.events;

        return _.extend(_.clone(parentEvents), {
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            Model: Coupon,
            ModalEditView: ModalView,
            ModelView: RowView
        });

        return ListEditablesView.prototype.initialize.apply(
            this, [this.options]
        );
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/coupons/Main.js